import Image from "next/image";

export default function TestimonialCard({
  name,
  quote,
  photoUrl,
}: {
  name: string;
  quote: string;
  photoUrl: string;
}) {
  return (
    <div className="relative flex h-full w-full flex-col p-3">
      <Image
        width={180}
        height={180}
        src={photoUrl}
        alt={`${name} photograph`}
        className="absolute top-12 z-9 ml-8 aspect-square h-45 w-45 rounded-full blur-lg"
        sizes="180px"
      />
      <Image
        width={180}
        height={180}
        src={photoUrl}
        alt={`${name} photograph`}
        className="absolute top-8 z-10 ml-8 aspect-square h-45 w-45 rounded-full"
        sizes="180px"
      />
      <div className="border-accent-light relative mt-[180px] flex min-h-[320px] w-full grow flex-col justify-between rounded-3xl border-6 px-10 pt-16 pb-4 md:mt-[160px] lg:pt-24">
        <p className="text-xl leading-relaxed first-letter:text-3xl">{quote}</p>
        <p className="mt-6 text-right text-xl font-semibold">{name}</p>
        <Image
          src="/icons/quote.svg"
          alt="quote icon"
          width={100}
          height={80}
          className="absolute bottom-6 left-6 h-auto w-25"
        />
      </div>
    </div>
  );
}
